import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations'
import { FS3Notification } from '../../objects/notification';
import { SharedDataService } from '../../services/shared-data.service';
import { SubscriptionLike } from 'rxjs';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})


export class NotificationComponent implements OnInit, OnDestroy {
  public static CLEAR_INTERVAL = 5000;

  public messages: FS3Notification[] = [];
  private progressSubscribe: SubscriptionLike;

  constructor(private sharedDataService: SharedDataService) {
  }

  ngOnInit() {
    this.progressSubscribe = this.sharedDataService.notificationsObservable$.subscribe(
      notification => {
        if (this.messages.length >= 3) {
          this.messages.shift()
        }
        this.messages.push(notification);
        setTimeout(() => {
          this.messages.shift()
        }, NotificationComponent.CLEAR_INTERVAL)
      });
  }

  ngOnDestroy() {
    this.progressSubscribe.unsubscribe();
  }

}

